<template>
    <Layout>
        <div ref="mainContainer" class="main-container" v-loading="isLoading">
            <BlogDetail :blog="data" v-if="data" />
            <BlogComment v-if="!isLoading"/>
        </div>
        <template #right>
            <div class="right-container" v-loading="isLoading">
                <BlogToc :toc="data.toc" v-if="data" />
            </div>
        </template>
    </Layout>
</template>

<script>
import fetchData from "@/mixins/fetchData";
import { getBlog } from "@/api/blog";
import Layout from "@/components/Layout.vue";
import BlogDetail from "./components/BlogDetail.vue";
import BlogToc from "./components/BlogToc.vue";
import BlogComment from "./components/BlogComment.vue";
import mainScroll from "@/mixins/mainScroll";

export default {
    mixins: [fetchData(null),mainScroll("mainContainer")],
    components: {
        Layout,
        BlogDetail,
        BlogToc,
        BlogComment,
    },
    methods: {
        async fetchData() {
            return await getBlog(this.$route.params.id);
        },
        // handleScroll(){
        //     this.$bus.$emit("mainScroll",this.$refs.mainContainer);
        // },
        // handleSetMainScroll(scrollTop){
        //     this.$refs.mainContainer.scrollTop=scrollTop;
        // }
    },
   
    // mounted(){
    //     this.$bus.$on("setMainScroll",this.handleSetMainScroll);
    //     this.$refs.mainContainer.addEventListener("scroll",this.handleScroll)
    // },
    // beforeDestroyed(){
    //     this.$bus.$emit("mainScroll")
    //     this.$refs.mainContainer.removeEventListener("scroll",this.handleScroll)
    //     this.$bus.$off("setMainScroll",this.handleSetMainScroll);
    // },
    updated(){
        const hash = location.hash;
        location.hash="";
        setTimeout(()=>{
            location.hash=hash;
        },50)
    }
}
</script>

<style scoped lang="less">
.main-container {
    height: 100%;
    overflow-y: scroll;
    box-sizing: border-box;
    padding: 20px;
    position: relative;
    width: 100%;
    scroll-behavior: smooth;
}

.right-container {
    width: 300px;
    height: 100%;
    overflow-y: scroll;
    box-sizing: border-box;
    position: relative;
    box-sizing: border-box;
    padding: 20px;
}
</style>